import axios from "axios";
import { authHeader } from "../authservice/auth-header";

const API_URL =process.env.VUE_APP_ROOT_API
class InvoicelyService {
  // Get invoicely account list
  async getInvoicelyAccounts() {
    return await axios
      .get(API_URL + "crm/spa/account", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Add  new invoicely account data
  async addInvoicelyAccounts(data) {
    return await axios
      .post(API_URL + "crm/spa/account", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Edit invoicely account
  async editInvoicelyAccounts(id, data) {
    return await axios
      .patch(API_URL + "crm/spa/account/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get Invoicely Admin List
  async getCRMAdminList() {
    return await axios
      .get(API_URL + "user/spa/crm/admin", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Add Invoicely Admin
  async addCRMAdminList(data) {
    return await axios
      .post(API_URL + "user/spa/crm/admin", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Edit Invoicely Admin account
  async editCRMAdminList(id, data) {
    return await axios
      .patch(API_URL + "user/spa/crm/admin/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Delete Invoicely Admin account
  async deleteCRMAdmin(id) {
    return await axios
      .delete(API_URL + "user/spa/crm/admin/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Get customer list
  async getCustomerListPBX(filter) {
    return await axios
      .get(API_URL + "crm/company" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}
export default new InvoicelyService();
